import { render, staticRenderFns } from "./InsVoto.vue?vue&type=template&id=5e54286a&scoped=true&"
import script from "./InsVoto.vue?vue&type=script&lang=js&"
export * from "./InsVoto.vue?vue&type=script&lang=js&"
import style0 from "./InsVoto.vue?vue&type=style&index=0&id=5e54286a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e54286a",
  null
  
)

export default component.exports